import React from 'react';

function SvgCubes() {
  return (
    <svg
        className="meuble cubes"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 113.16 120.4"
    >
      <defs>
        <style>
          {
            ".cubes_svg__cube .cubes_svg__cls-1{fill:#ce6949}.cubes_svg__cube .cubes_svg__cls-2{fill:#efbb51}.cubes_svg__cube .cubes_svg__cls-3{fill:#7ac8cf}.cubes_svg__cube .cubes_svg__cls-4{fill:#b0af3e}.cubes_svg__cube .cubes_svg__cls-5{fill:#fff3dd}"
          }
        </style>
      </defs>
      <g
        id="cubes_svg__Calque_2"
        className="cubes_svg__cube meuble"
        data-name="Calque cubes_svg__cube2"
      >
        <g id="cubes_svg__BABY_ROOM" data-name="BABY ROOM">
          <g id="cubes_svg__Calque_22" data-name="Calque 22">
            <path
              className="cubes_svg__cls-1"
              transform="rotate(-83.29 102.122 109.208)"
              d="M92.18 99.27h19.88v19.89H92.18z"
            />
            <path
              className="cubes_svg__cls-2"
              d="M45.1 100.34h20.06v20.05H45.1z"
            />
            <path
              className="cubes_svg__cls-3"
              d="M54.45 80.12h20.06v20.06H54.45z"
            />
            <path
              className="cubes_svg__cls-2"
              d="M49.41 60.05H70.5v20.06H49.41z"
            />
            <path
              className="cubes_svg__cls-3"
              d="M71.2 100.34h20.05v20.05H71.2z"
            />
            <path
              className="cubes_svg__cls-4"
              d="M52.57 40.09h20.06v20.06H52.57z"
            />
            <path
              className="cubes_svg__cls-1"
              d="M34.31 80.13h20.05v20.06H34.31z"
            />
            <path
              className="cubes_svg__cls-4"
              d="M21.54 100.34h22.81v20.05H21.54z"
            />
            <path className="cubes_svg__cls-1" d="M0 100.34h20.06v20.05H0z" />
            <path
              className="cubes_svg__cls-2"
              d="M43.74 20.08H63.8v20.06H43.74z"
            />
            <path
              className="cubes_svg__cls-3"
              d="M39.07 0h20.06v20.06H39.07zM29.21 40.09h20.05v20.06H29.21z"
            />
            <path
              className="cubes_svg__cls-1"
              d="M26.22 60.05h20.05v20.06H26.22z"
            />
            <path
              className="cubes_svg__cls-2"
              d="M10.28 80.13h20.06v20.05H10.28z"
            />
            <path
              className="cubes_svg__cls-5"
              d="M47.67 14.94v-10l1.67-.65H51v10.65zM57.76 24.73v1.32l-.52 1.35h-3.6v1.2h2.86a1.27 1.27 0 011.32 1.33v4.12a1.27 1.27 0 01-1.32 1.32h-6.19v-2.65h4.2v-1.47h-4.2v-6.52zM54 75.8v-10l1.68-.66h1.65V75.8zM59.91 75.8a1.27 1.27 0 01-1.32-1.32v-8a1.27 1.27 0 011.32-1.33h4.85a1.28 1.28 0 011.34 1.33v8a1.28 1.28 0 01-1.34 1.32zm2-8v5.33h.87v-5.3zM36.07 111.88V116a1.28 1.28 0 01-1.34 1.32h-4.86a1.27 1.27 0 01-1.32-1.32v-8a1.27 1.27 0 011.32-1.33h6.06V108l-.52 1.35h-3.54v1.2h2.86a1.28 1.28 0 011.34 1.33zm-3.33 1.33h-.87v1.47h.87zM43.67 55.58a1.26 1.26 0 01-1.32 1.32h-6.19v-2.64h4.2v-1.48H38v-1.65l1.76-1.63v-.56h-3l-.53-1.36v-1.32h7.45v2.54l-1.29 1.72a1.28 1.28 0 011.35 1.38zM79.79 108.26h-3.13v-2.67h6.54v2.73l-2.57 7.91h-3.09v-.85l2.25-6.75zM60.64 54.26v-2.69A1.29 1.29 0 0162 50.29V50a1.29 1.29 0 01-1.36-1.28v-2.46A1.28 1.28 0 0162 44.94h4.85a1.27 1.27 0 011.33 1.32v2.45A1.29 1.29 0 0166.79 50v.3a1.29 1.29 0 011.36 1.28v2.69a1.28 1.28 0 01-1.33 1.33H62a1.27 1.27 0 01-1.36-1.34zM64 48.82h.86v-1.2H64zm0 4.12h.86v-1.48H64zM22.13 93.23v.58h4.19v2.65H18.8v-3.53a1.75 1.75 0 01.9-1.81l3.3-2.07v-.56h-3.67l-.53-1.36v-1.32H25a1.27 1.27 0 011.33 1.32v2.44a1.73 1.73 0 01-.9 1.81zM45.38 85.15v1.32L44 90.57v.56h1.3V89.2h3.34v6.6h-3.39v-2h-4.7v-3.26l1.88-5.39zM103.51 104l-.22 1.3-2.1 3.79-.09.56 1.28.22.33-1.9 3.28.56-1.11 6.5-3.28-.56.33-2-4.63-.8.55-3.21 2.75-5zM50.59 110.39v-4.14a1.27 1.27 0 011.33-1.32h4.85a1.27 1.27 0 011.34 1.32v8a1.28 1.28 0 01-1.34 1.32H51v-2.64h3.8v-1.2h-2.88a1.28 1.28 0 01-1.33-1.34zm3.32-1.33h.87v-1.46h-.87zM61.51 95.36v-10l1.68-.66h1.66v10.66zM39.14 68.49H36v-2.67h6.54v2.73L40 76.46h-3.11v-.85l2.25-6.75zM15.35 105.15v1.32l-.52 1.35h-3.6V109h2.86a1.26 1.26 0 011.32 1.32v4.12a1.26 1.26 0 01-1.32 1.32H7.9v-2.64h4.2v-1.48H7.9v-6.52z"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgCubes;
